import { useIntl } from '@capsicum/common';
import { useNonCustodialWallet } from '@socios-blk/core';

export const useNCWAddressCopyCard = () => {
	const { $t } = useIntl();
	const cardTitle = $t('ncWallet.receive.depositAddressChz.title');
	const copyButtonText = $t('ncWallet.receive.depositAddressChz.copyButtonText');
	const backButtonText = $t('ncWallet.receive.depositAddressChz.backButtonText');
	const waitForAddress = $t('ncWallet.receive.depositAddressChz.waitForAddress');
	const snackbarText = $t('ncWallet.receive.depositAddressChz.snackbarText');

	const { data, isLoading } = useNonCustodialWallet();
	const { blockchainAddress } = data?.nonCustodialWallet ?? {};

	const askUserToAwaitAddress = !isLoading && !blockchainAddress;
	const addressNotAvailable = askUserToAwaitAddress || isLoading;

	return {
		addressNotAvailable,
		askUserToAwaitAddress,
		blockchainAddress,
		intlText: {
			backButtonText,
			cardTitle,
			copyButtonText,
			snackbarText,
			waitForAddress
		},

		isLoading
	};
};
